// B1 - Ünite 3: Comparatives & Superlatives
// Hedef: Karşılaştırma: bigger, more comfortable, the best

export const B1_UNIT_3 = {
  'B1-U3-L1': {
    id: 'B1-U3-L1',
    title: 'Short Adjectives: -er, -est',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Kısa Sıfatlar - Comparative (-er)',
          explanation: '1-2 heceli kısa sıfatlara -er eklenir.',
          table: {
            headers: ['Sıfat', 'Comparative', 'Örnek'],
            rows: [
              ['big', 'bigger', 'This plane is bigger.'],
              ['fast', 'faster', 'The A380 is faster.'],
              ['cheap', 'cheaper', 'Economy is cheaper.'],
              ['safe', 'safer', 'Flying is safer than driving.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '📚 Kısa Sıfatlar - Superlative (-est)',
          table: {
            headers: ['Sıfat', 'Superlative', 'Örnek'],
            rows: [
              ['big', 'the biggest', 'This is the biggest aircraft.'],
              ['fast', 'the fastest', 'It\'s the fastest plane.'],
              ['cheap', 'the cheapest', 'This is the cheapest ticket.'],
              ['safe', 'the safest', 'Flying is the safest way to travel.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Yazım kuralları: big → bigger (ünlü+ünsüz = ünsüz 2x) | happy → happier (y → i)'
        },
        {
          type: 'vocabulary',
          title: '✈️ Havacılıkta Karşılaştırma',
          words: [
            { en: 'bigger', tr: 'daha büyük', pronunciation: '' },
            { en: 'faster', tr: 'daha hızlı', pronunciation: '' },
            { en: 'longer', tr: 'daha uzun', pronunciation: '' },
            { en: 'newer', tr: 'daha yeni', pronunciation: '' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'This aircraft is _____ than that one.',
          options: ['bigger', 'more big', 'biger', 'biggest'],
          correct: 'bigger',
          explanation: 'big → bigger (kısa sıfat + er)'
        },
        {
          type: 'multipleChoice',
          question: 'This is _____ flight in our schedule.',
          options: ['the longest', 'the longer', 'longest', 'more long'],
          correct: 'the longest',
          explanation: 'Superlative: the + sıfat + est'
        },
        {
          type: 'fillInBlank',
          sentence: 'Economy class is _____ (cheap) than business class.',
          answer: 'cheaper',
          hint: 'Comparative: cheap + er'
        },
        {
          type: 'fillInBlank',
          sentence: 'This is _____ (safe) airline in the world.',
          answer: 'the safest',
          hint: 'Superlative: the + safe + st'
        },
        {
          type: 'dragDrop',
          instruction: '🔀 Cümleyi doğru sıraya dizin',
          words: ['bigger', 'is', 'plane', 'This', 'than', 'that'],
          correctOrder: [3, 2, 1, 0, 4, 5],
          translation: 'Bu uçak o uçaktan daha büyük.'
        },
        {
          type: 'flashcard',
          title: '🎴 Comparatives & Superlatives',
          cards: [
            { front: 'big → bigger → biggest', back: 'büyük → daha büyük → en büyük' },
            { front: 'fast → faster → fastest', back: 'hızlı → daha hızlı → en hızlı' },
            { front: 'long → longer → longest', back: 'uzun → daha uzun → en uzun' },
            { front: 'safe → safer → safest', back: 'güvenli → daha güvenli → en güvenli' },
            { front: 'good → better → best', back: 'iyi → daha iyi → en iyi' },
            { front: 'bad → worse → worst', back: 'kötü → daha kötü → en kötü' }
          ]
        },
        {
          type: 'timeRace',
          title: '⏱️ Comparative Yarışı',
          cards: [
            { front: 'big', back: 'bigger' },
            { front: 'fast', back: 'faster' },
            { front: 'long', back: 'longer' },
            { front: 'safe', back: 'safer' },
            { front: 'cheap', back: 'cheaper' },
            { front: 'good', back: 'better' },
            { front: 'bad', back: 'worse' },
            { front: 'new', back: 'newer' }
          ]
        }
      ]
    }
  },
  'B1-U3-L2': {
    id: 'B1-U3-L2',
    title: 'Long Adjectives: more, most',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Uzun Sıfatlar - Comparative (more)',
          explanation: '3+ heceli sıfatlarda "more" kullanılır.',
          table: {
            headers: ['Sıfat', 'Comparative', 'Örnek'],
            rows: [
              ['comfortable', 'more comfortable', 'Business class is more comfortable.'],
              ['expensive', 'more expensive', 'First class is more expensive.'],
              ['professional', 'more professional', 'She is more professional.'],
              ['experienced', 'more experienced', 'He is more experienced.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '📚 Uzun Sıfatlar - Superlative (most)',
          table: {
            headers: ['Sıfat', 'Superlative', 'Örnek'],
            rows: [
              ['comfortable', 'the most comfortable', 'This is the most comfortable seat.'],
              ['expensive', 'the most expensive', 'First class is the most expensive.'],
              ['professional', 'the most professional', 'They are the most professional crew.'],
              ['important', 'the most important', 'Safety is the most important.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Kısa sıfat = -er/-est | Uzun sıfat = more/most | beautiful, comfortable, experienced = UZUN'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Business class is _____ than economy.',
          options: ['more comfortable', 'comfortabler', 'most comfortable', 'comfortable'],
          correct: 'more comfortable',
          explanation: 'Uzun sıfat: more + sıfat'
        },
        {
          type: 'multipleChoice',
          question: 'This is _____ airline.',
          options: ['the most professional', 'the more professional', 'most professional', 'professionaler'],
          correct: 'the most professional',
          explanation: 'Superlative: the most + sıfat'
        },
        {
          type: 'fillInBlank',
          sentence: 'She is _____ (experienced) than me.',
          answer: 'more experienced',
          hint: 'Uzun sıfat: more + sıfat'
        },
        {
          type: 'fillInBlank',
          sentence: 'Safety is _____ (important) thing.',
          answer: 'the most important',
          hint: 'Superlative: the most + sıfat'
        }
      ]
    }
  },
  'B1-U3-L3': {
    id: 'B1-U3-L3',
    title: 'Irregular: good-better-best',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Düzensiz Sıfatlar',
          table: {
            headers: ['Sıfat', 'Comparative', 'Superlative'],
            rows: [
              ['good', 'better', 'the best'],
              ['bad', 'worse', 'the worst'],
              ['far', 'farther/further', 'the farthest/furthest'],
              ['little', 'less', 'the least'],
              ['much/many', 'more', 'the most']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Örnekleri',
          table: {
            headers: ['Cümle', 'Türkçesi'],
            rows: [
              ['This airline has the best service.', 'Bu havayolunun en iyi servisi var.'],
              ['The weather is worse today.', 'Hava bugün daha kötü.'],
              ['We need more time.', 'Daha fazla zamana ihtiyacımız var.'],
              ['This is the best flight I\'ve had.', 'Bu yaşadığım en iyi uçuş.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 good → better → best | bad → worse → worst | EZBERLEYİN!'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'This airline has _____ service in the world.',
          options: ['the best', 'the better', 'the goodest', 'better'],
          correct: 'the best',
          explanation: 'good → better → the best'
        },
        {
          type: 'multipleChoice',
          question: 'The weather is _____ than yesterday.',
          options: ['worse', 'more bad', 'badder', 'worst'],
          correct: 'worse',
          explanation: 'bad → worse → the worst'
        },
        {
          type: 'fillInBlank',
          sentence: 'This is _____ (good) flight I\'ve ever had.',
          answer: 'the best',
          hint: 'Superlative: good → the best'
        },
        {
          type: 'matching',
          instruction: 'Düzensiz sıfatları eşleştirin',
          pairs: [
            { left: 'good', right: 'better' },
            { left: 'bad', right: 'worse' },
            { left: 'much', right: 'more' },
            { left: 'little', right: 'less' }
          ]
        }
      ]
    }
  },
  'B1-U3-L4': {
    id: 'B1-U3-L4',
    title: 'As...as, not as...as',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 As...as (Eşitlik)',
          explanation: 'As + sıfat + as: iki şeyin eşit olduğunu belirtir.',
          table: {
            headers: ['Yapı', 'Örnek', 'Türkçesi'],
            rows: [
              ['as + adj + as', 'This flight is as long as the other.', 'Bu uçuş diğeri kadar uzun.'],
              ['as + adj + as', 'She is as professional as him.', 'O, onun kadar profesyonel.'],
              ['as + adj + as', 'Business class is as safe as economy.', 'Business class, economy kadar güvenli.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '📚 Not as...as (Eşitsizlik)',
          explanation: 'Not as + sıfat + as: bir şeyin diğerinden daha az olduğunu belirtir.',
          table: {
            headers: ['Örnek', 'Türkçesi', 'Anlam'],
            rows: [
              ['Economy is not as expensive as business.', 'Economy, business kadar pahalı değil.', 'Economy daha ucuz'],
              ['This plane is not as big as the A380.', 'Bu uçak A380 kadar büyük değil.', 'A380 daha büyük'],
              ['He is not as experienced as her.', 'O, onun kadar deneyimli değil.', 'O daha deneyimli']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 as...as = eşit | not as...as = daha az (öncekilere THAN gerekli değil!)'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'This flight is _____ long _____ the other.',
          options: ['as / as', 'so / as', 'more / than', 'as / than'],
          correct: 'as / as',
          explanation: 'Eşitlik: as + adj + as'
        },
        {
          type: 'multipleChoice',
          question: 'Economy is not _____ expensive _____ business.',
          options: ['as / as', 'so / than', 'more / as', 'as / than'],
          correct: 'as / as',
          explanation: 'Eşitsizlik: not as + adj + as'
        },
        {
          type: 'fillInBlank',
          sentence: 'This plane is _____ big _____ the A380.',
          answer: 'as / as',
          hint: 'as + sıfat + as'
        },
        {
          type: 'fillInBlank',
          sentence: 'She is not _____ experienced _____ him.',
          answer: 'as / as',
          hint: 'not as + sıfat + as'
        }
      ]
    }
  },
  'B1-U3-L5': {
    id: 'B1-U3-L5',
    title: 'Uygulama: Hizmet Karşılaştırma',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '✈️ Sınıf Karşılaştırması',
          table: {
            headers: ['Özellik', 'Economy', 'Business', 'First'],
            rows: [
              ['Koltuk', 'narrow', 'wider', 'the widest'],
              ['Yemek', 'good', 'better', 'the best'],
              ['Fiyat', 'cheap', 'more expensive', 'the most expensive'],
              ['Konfor', 'comfortable', 'more comfortable', 'the most comfortable']
            ]
          }
        },
        {
          type: 'vocabulary',
          title: '🎤 Mülakat: Karşılaştırma',
          words: [
            { en: 'I am more motivated than before.', tr: 'Öncekinden daha motive oluyorum.', pronunciation: '' },
            { en: 'This is the best opportunity for me.', tr: 'Bu benim için en iyi fırsat.', pronunciation: '' },
            { en: 'I will work harder than ever.', tr: 'Her zamankinden daha çok çalışacağım.', pronunciation: '' },
            { en: 'Customer satisfaction is the most important.', tr: 'Müşteri memnuniyeti en önemlisi.', pronunciation: '' }
          ]
        },
        {
          type: 'tip',
          content: '💡 Mülakatta: "Why should we hire you?" - I am more dedicated and hardworking than other candidates.'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Business class seats are _____ than economy seats.',
          options: ['wider', 'more wide', 'widest', 'most wide'],
          correct: 'wider',
          explanation: 'Kısa sıfat: wide + r'
        },
        {
          type: 'multipleChoice',
          question: 'First class is _____ class.',
          options: ['the most comfortable', 'the more comfortable', 'most comfortable', 'comfortablest'],
          correct: 'the most comfortable',
          explanation: 'Superlative: the most + uzun sıfat'
        },
        {
          type: 'speaking',
          instruction: 'Bu karşılaştırmaları söyleyin:',
          phrases: [
            'Business class is more comfortable than economy.',
            'This airline has the best service.',
            'I am more motivated than before.',
            'Customer satisfaction is the most important thing.'
          ]
        },
        {
          type: 'fillInBlank',
          sentence: 'I will work _____ (hard) than ever before.',
          answer: 'harder',
          hint: 'Comparative: hard + er'
        }
      ]
    }
  },
  'B1-U3-EXAM': {
    id: 'B1-U3-EXAM',
    title: 'Ünite 3 Sınavı',
    type: 'exam',
    exercises: [
      {
        type: 'multipleChoice',
        question: 'This aircraft is _____ than that one.',
        options: ['bigger', 'more big', 'biger', 'biggest'],
        correct: 'bigger',
        explanation: 'Kısa sıfat: big + ger'
      },
      {
        type: 'multipleChoice',
        question: 'Business class is _____ than economy.',
        options: ['more comfortable', 'comfortabler', 'most comfortable', 'comfortable'],
        correct: 'more comfortable',
        explanation: 'Uzun sıfat: more + comfortable'
      },
      {
        type: 'multipleChoice',
        question: 'This airline has _____ service in the world.',
        options: ['the best', 'the better', 'the goodest', 'better'],
        correct: 'the best',
        explanation: 'Düzensiz: good → the best'
      },
      {
        type: 'multipleChoice',
        question: 'The weather is _____ than yesterday.',
        options: ['worse', 'more bad', 'badder', 'worst'],
        correct: 'worse',
        explanation: 'Düzensiz: bad → worse'
      },
      {
        type: 'multipleChoice',
        question: 'Economy is not _____ expensive _____ business.',
        options: ['as / as', 'so / than', 'more / as', 'as / than'],
        correct: 'as / as',
        explanation: 'Eşitsizlik: not as...as'
      },
      {
        type: 'fillInBlank',
        sentence: 'This is _____ (long) flight in our schedule.',
        answer: 'the longest',
        hint: 'Superlative: the + long + est'
      },
      {
        type: 'matchPairs',
        instruction: 'Düzensiz sıfatları eşleştirin',
        pairs: [
          { left: 'good', right: 'better' },
          { left: 'bad', right: 'worse' },
          { left: 'much', right: 'more' },
          { left: 'far', right: 'farther' }
        ]
      }
    ]
  }
};

export default B1_UNIT_3;
